import { CONSENT, OFFERING } from '@shared/config.js';

/**
 * Legal footer, present on every screen.
 *
 * The Impressum is not optional: §5 DDG (formerly TMG) requires a provider
 * identification reachable from every page of a commercial site in Germany,
 * and it must be reachable in at most two clicks. Because this tool runs on its
 * own domain rather than under nttdata.com, the links point at NTT DATA
 * Deutschland SE as the controller and operator.
 *
 * The URLs below are placeholders pointing at NTT DATA's corporate pages.
 * Legal has NOT signed these off — see README "Known gaps". Before this domain
 * is shared publicly, either a dedicated Impressum/privacy notice for this
 * service is published, or these are confirmed as sufficient.
 */

const LINKS: { label: string; href: string; note?: string }[] = [
  { label: 'Imprint', href: 'https://www.nttdata.com/global/en/imprint' },
  { label: 'Privacy notice', href: CONSENT.privacyNoticeUrl },
  { label: 'Accessibility', href: 'https://www.nttdata.com/global/en/accessibility' },
  { label: 'Contact', href: `mailto:${OFFERING.contactEmail}` },
];

export function LegalFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="legal-footer">
      <nav className="legal-footer-links" aria-label="Legal">
        {LINKS.map((l) => (
          <a
            key={l.label}
            href={l.href}
            {...(l.href.startsWith('http') ? { target: '_blank', rel: 'noreferrer' } : {})}
          >
            {l.label}
          </a>
        ))}
      </nav>

      <p className="legal-footer-meta">
        Controller: <b>{CONSENT.controller}</b>. Details submitted here are processed to generate
        and provide the {OFFERING.deliverable}, kept for 12 months, and deleted on request at{' '}
        <a href={`mailto:${CONSENT.withdrawalContact}`}>{CONSENT.withdrawalContact}</a>.
      </p>

      {/* Stating this plainly is worth more than a cookie banner nobody reads —
          and it is only true because the app genuinely sets no cookies. */}
      <p className="legal-footer-meta">
        This site sets no cookies and uses no third-party trackers. We count only how many scans
        start, finish and convert — no profile is built and no data is shared with advertisers.
      </p>

      <p className="legal-footer-copy">
        © {year} NTT DATA Deutschland SE · {OFFERING.name} · NDSS and the {OFFERING.deliverable}{' '}
        are indicative at this tier (evidence level E1).
      </p>
    </footer>
  );
}
